import urlJoin from 'url-join';

export const baseURLConfigurator = process.env.REACT_APP_API_CONFIGURATOR || "";

export const fetchMultistageOlympiadWidgetList = async () => {
  const url = urlJoin(baseURLConfigurator, '/api/configurator/public?configs=cabmun_multistage_olympiad_widget_list');
  const response = await fetch(url);
  const data = await response.json();
  return data?.cabmun_multistage_olympiad_widget_list;
};
